export default {
    getActive: state => {
        for (let i = 0, l = state.rects.length; i < l; i++) {
            let rect = state.rects[i];

            if (rect.active && rect.draggable) {
                return i;
            }
        }
        return null;
    },
    activePreview: state => {
        return state.activePreview;
    }
}